export default "__VITE_ASSET__DHS81h9Q__"